import { gql } from '@lcs/shared/api';

export const deleteMailboxMessagesMutation = gql`
   mutation DeleteMailboxMessages($mailboxMessageIds: [UInt!]!) {
      deleteMailboxMessages(ids: $mailboxMessageIds)
   }
`;
